module.exports = __webpack_public_path__ + "img/pcbg.7e4010c8.jpg";